import React, { useCallback, useState } from "react"
import "./ShipmentAddCsvTrack.scss"
import { Button, message, Upload } from 'antd';
import { getIcon } from "../../../utils/images";
import { convertAndTrackUploadedCsv, downloadTrackingSampleFile } from "../../../services/shipments";

const ShipmentAddCsvTrack = ({refetch, close}) => {
  const [uploadedFileName, setUploadedFileName] = useState(null);
  const [buttonClicked, setButtonClicked] = useState(false)

  const props = {
    name: 'file',
    maxCount: 1,
    action:  `${process.env.REACT_APP_ROOT_HOST}${process.env.REACT_APP_BASE_API}shipments/upload_csv_tracking`,
    headers: {
      authorization: 'authorization-text',
      'X-CSRF-TOKEN': document.querySelector('[name=csrf-token]').content
    },
    accept: "text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    onChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`);
        setUploadedFileName(info.file.response.file_name)
      } else if (info.file.status === 'error') {
        const errorMsg = info.fileList[0]?.response?.error
        message.error(`${info.file.name} file upload failed.`);
        if (errorMsg) message.error(errorMsg)
      }
    },
  };

  async function handleNextButtonClick(e) {
    try {
      setButtonClicked(true)
      let upload = await convertAndTrackUploadedCsv({uploadedFileName});
      if (upload["data"]["error"]) {
        throw new Error(upload["data"]["error"]); // You can customize the error message
      } else {
        message.success(`Tracking Shipments created successfully`);
      }
      refetch();
      close();
    } catch (error) {
      message.error(`${error}`)
    } finally {
      setButtonClicked(false)
    }
  }

  const handleDownloadClick = () => {
    downloadTrackingSampleFile()
      .then(response => {
        // After the request completes, handle the download
        const link = document.createElement('a');
        link.href = `/${process.env.REACT_APP_TRACKING_SAMPLE_FILE}`;
        link.setAttribute('download', process.env.REACT_APP_TRACKING_SAMPLE_FILE); // Set the filename
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link); // Remove the link after triggering the download
      })
      .catch(error => {
        console.error('Error downloading file:', error);
      });
  };
  
  return (
    <div className="ShipmentAddCsvTrack">
      <div className="header">
        <div className="header__title">Upload Shipments Excel Sheet</div>
      </div>
      <div className="sample-wrapper">
        <div className="header__subtitle">{"Upload the your shipments file. This file must be similar to Nowlun Sample File. You can download the sample file and use it by filling in your shipments data."}</div>
        <div>
          <a className="engraved-btn" onClick={(e) => {
              e.preventDefault(); 
              handleDownloadClick(); 
            }} href=''>
            <img src={getIcon('download-sample')} />
            Download Sample File
          </a>
        </div>
      </div>
      <div className="all-upload-wrapper">
        <div className="upload-wrapper">
          <img src={getIcon('upload')} />
          <div className="header__subtitle">{"Upload the your shipments file"}</div>
          <Upload {...props}>
            <Button className="bold-btn"><img src={getIcon('small-upload')} />Upload File</Button>
          </Upload>
        </div>
      </div>
      <div className="actions-wrapper">
        <Button className="bold-btn" onClick={handleNextButtonClick} disabled={!uploadedFileName || buttonClicked}>
          Next
        </Button>
      </div>

      
    </div>
  )
}

export default ShipmentAddCsvTrack;

